import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

const BackButton = ({ handleOnClick, label }: { handleOnClick: () => void; label: string }) => {
  return (
    <>
      <Button
        component="button"
        onClick={handleOnClick}
        data-testid="mobile-top-menu-back-button"
        sx={{
          height: 42,
          textAlign: 'left',
          display: 'flex',
          justifyContent: 'start',
          gap: '8px',
          padding: '9px 12px',
        }}
      >
        <ChevronLeftIcon sx={{ height: '32px', width: '32px' }} />
        <Typography fontWeight={700} fontSize={16} color="rgba(0, 0, 0, 1)">
          {label}
        </Typography>
      </Button>
      <Divider />
    </>
  );
};

export default BackButton;
